import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider,verifyPasswordResetCode,confirmPasswordReset} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyATF07LN0z5D5dB7oCgp-lFmEEEjZLSigQ",
  authDomain: "comms-ai-prod.firebaseapp.com",
  projectId: "comms-ai-prod",
  storageBucket: "comms-ai-prod.firebasestorage.app",
  messagingSenderId: "936491458221",
  appId: "1:936491458221:web:c734ab321e38257cd1f024"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider('microsoft.com');

export { auth, googleProvider, microsoftProvider,verifyPasswordResetCode,confirmPasswordReset};